import { render, staticRenderFns } from "./jianzhancommon.vue?vue&type=template&id=27e9706a&scoped=true"
import script from "./jianzhancommon.vue?vue&type=script&lang=js"
export * from "./jianzhancommon.vue?vue&type=script&lang=js"
import style0 from "./jianzhancommon.vue?vue&type=style&index=0&id=27e9706a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e9706a",
  null
  
)

export default component.exports